export class Client {
  id: number = null;
  account: string = null;
  name: string = null;
  legalName: string = null;
  dob: Date = null;
  phone: string = null;
  email: string = null;
  currency: string = null;
}
